// src/pages/StationMap.js
import L from 'leaflet';
// src/pages/StationMap.js
import React, { useEffect, useState } from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import stationService from '../../services/stationService';
// import { securityIcon, medicalIcon, defaultIcon } from './Icons'; // Import the icons

// Ambulance icon
export const ambulanceIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/2965/2965281.png', // Ambulance icon
  iconSize: [40, 40],
});

// Security icon
export const securityIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/1454/1454869.png', // Security icon
  iconSize: [40, 40],
});

// Medical icon
export const medicalIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/616/616448.png', // Medical icon
  iconSize: [40, 40],
});

// Default icon for other stations
export const defaultIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/1524/1524545.png', // Default station icon
  iconSize: [40, 40],
});

const StationMap = () => {
  const [stations, setStations] = useState([]);

  useEffect(() => {
    const fetchStations = async () => {
      const response = await stationService.getStations();  // Fetch all station types
      setStations(response.data);
    };

    fetchStations();
  }, []);

  const getStationIcon = (stationType) => {
    switch (stationType.toLowerCase()) {
      case 'ambulance':
        return ambulanceIcon;
      case 'security':
        return securityIcon;
      case 'medical':
        return medicalIcon;
      default:
        return defaultIcon;
    }
  };

  return (
    <MapContainer center={[20.5937, 78.9629]} zoom={5} style={{ height: '600px', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {stations.map((station) => (
        <Marker
          key={station.id}
          position={[station.latitude, station.longitude]}
          icon={getStationIcon(station.station_type)}
        >
          <Popup>
            <b>{station.station_name}</b> <br /> Type: {station.station_type} <br /> Lat: {station.latitude} <br /> Long: {station.longitude}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default StationMap;
